import React from "react";
import { IonLoading } from "@ionic/react";

type props = {
    showLoading: any;
    backdropDismiss?: any;
};
export const Loading = ({ showLoading, backdropDismiss=true }: props) => {

  return (
      <IonLoading
        cssClass="my-custom-class"
        isOpen={showLoading}
        message={"Please wait..."} backdropDismiss={backdropDismiss}
      />
  );
};
